function DashboardControls() {
    "use strict";

    this.ListView = null;
    this.ListViewFilter = null;
    this.ListViewPaginator = null;
    this.SortReportListView = null;
    this.Tiles = {};

    this.ColumnsListView = null;
    this.ColumnsDropdown = null;
    this.EventsListView = null;
    this.EventsListViewPaginator = null;
    this.NotesManager = null;
    this.ReportColumnValidator = null;
    this.ReportColumnUpdateValidator = null;


    // Map
    this.LastLocationMap = null;
}
if (typeof exports !== 'undefined') {
    module.exports = DashboardControls;
}